var _rect, _path, _path2, _rect2, _g, _path3, _path4, _g2, _path5, _path6, _path7, _rect3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFkp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2441_3837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2441_3837)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2441_3837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2441_3837)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2441_3837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 14
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.9375,
    height: 13.4167,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2441_3837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.44055 12.4582L1.40638 14.123L13.0021 1.81011L14.5038 -0.663855L11.4594 -1.22029L6.7298 4.08571L2.92294 7.66071L-1.44055 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.05078 13.6247L0.3996 14.5908L13.9646 -0.893656H11.9281L-1.05078 13.6247Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3781 12.4582L11.5311 14.123L-0.0646162 1.81011L-1.56631 -0.663855L1.47808 -1.22029L6.2077 4.08571L10.0146 7.66071L14.3781 12.4582Z",
    fill: "#F7FCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2809 13.2956L12.8305 14.2617L7.05439 7.63201L5.3419 6.89129L-1.71083 -0.655139H0.325672L7.37444 6.71217L9.24675 7.60037L14.2809 13.2956Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-1_2441_3837",
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 15,
    height: 16,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -1,
    y: -1,
    width: 15,
    height: 16
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.17637 0H5.73887V5.75H0V7.66667H5.73887V13.4167H7.17637V7.66667H12.9375V5.75H7.17637V0Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.73887 0V-0.75H4.98887V0H5.73887ZM7.17637 0H7.92637V-0.75H7.17637V0ZM5.73887 5.75V6.5H6.48887V5.75H5.73887ZM0 5.75V5H-0.75V5.75H0ZM0 7.66667H-0.75V8.41667H0V7.66667ZM5.73887 7.66667H6.48887V6.91667H5.73887V7.66667ZM5.73887 13.4167H4.98887V14.1667H5.73887V13.4167ZM7.17637 13.4167V14.1667H7.92637V13.4167H7.17637ZM7.17637 7.66667V6.91667H6.42637V7.66667H7.17637ZM12.9375 7.66667V8.41667H13.6875V7.66667H12.9375ZM12.9375 5.75H13.6875V5H12.9375V5.75ZM7.17637 5.75H6.42637V6.5H7.17637V5.75ZM5.73887 0.75H7.17637V-0.75H5.73887V0.75ZM6.48887 5.75V0H4.98887V5.75H6.48887ZM0 6.5H5.73887V5H0V6.5ZM0.75 7.66667V5.75H-0.75V7.66667H0.75ZM5.73887 6.91667H0V8.41667H5.73887V6.91667ZM6.48887 13.4167V7.66667H4.98887V13.4167H6.48887ZM7.17637 12.6667H5.73887V14.1667H7.17637V12.6667ZM6.42637 7.66667V13.4167H7.92637V7.66667H6.42637ZM12.9375 6.91667H7.17637V8.41667H12.9375V6.91667ZM12.1875 5.75V7.66667H13.6875V5.75H12.1875ZM7.17637 6.5H12.9375V5H7.17637V6.5ZM6.42637 0V5.75H7.92637V0H6.42637Z",
    fill: "#F7FCFF",
    mask: "url(#path-10-outside-1_2441_3837)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6517 19.0072C17.9134 19.0072 17.3897 18.7759 17.0094 18.3547C16.6243 17.928 16.3746 17.2936 16.2168 16.4657C15.9475 15.0525 15.9541 13.1295 15.962 10.8416C15.9632 10.4831 15.9645 10.1156 15.9647 9.73975H21.3996C21.498 12.0811 21.5401 14.3958 21.1911 16.1334C21.0136 17.0168 20.7375 17.7372 20.3276 18.2349C19.9224 18.7269 19.3817 19.0072 18.6517 19.0072Z",
    fill: "#6DC2FF",
    stroke: "#F7FCFF",
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2441_3837",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 9,
    width: 7,
    height: 11
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6517 19.0072C17.9134 19.0072 17.3897 18.7759 17.0094 18.3547C16.6243 17.928 16.3746 17.2936 16.2168 16.4657C15.9475 15.0525 15.9541 13.1295 15.962 10.8416C15.9632 10.4831 15.9645 10.1156 15.9647 9.73975H21.3996C21.498 12.0811 21.5401 14.3958 21.1911 16.1334C21.0136 17.0168 20.7375 17.7372 20.3276 18.2349C19.9224 18.7269 19.3817 19.0072 18.6517 19.0072Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2441_3837)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 13.0209C17.625 13.0209 17.3413 12.7412 17.2197 12.288C17.0981 11.8347 16.8574 10.6283 16.8574 10.5235C16.8574 10.4187 16.5371 10.5235 16.5371 10.5235C16.5371 10.5235 16.5416 10.0133 16.6624 10.0133C16.7833 10.0133 16.7878 9.54025 17.0811 9.65938C17.3743 9.77851 17.6049 10.2154 17.9037 10.2154C18.2026 10.2154 19.4518 10.3424 19.6525 10.3424C19.8533 10.3424 20.3827 10.9075 20.3827 11.3305C20.3827 11.7535 20.2383 12.3837 20.1248 12.3837C20.0112 12.3837 19.8684 12.7504 19.6525 12.6294C19.4367 12.5083 18.9214 12.2591 18.4599 12.3837C17.9983 12.5083 17.9037 12.43 17.9037 12.6294C17.9037 12.8287 17.625 13.0209 17.625 13.0209Z",
    fill: "#E1E5E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9624 12.7256H20.668L20.0297 13.8253H17.4115L16.9624 12.7256Z",
    fill: "#49801E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9142 17.5334C16.9142 17.5334 17.5546 17.8388 17.8223 17.8017C18.1187 17.7606 18.3811 17.3101 18.5792 17.3101C18.7769 17.3101 19.1576 17.7607 19.4533 17.8017C19.7214 17.8388 20.2442 17.5334 20.2442 17.5334",
    stroke: "white",
    strokeWidth: 0.533333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2109 16.2304C16.4324 15.9804 16.9143 15.9621 16.9143 15.9621C16.9143 15.9621 17.5547 16.2675 17.8223 16.2304C18.1187 16.1893 18.3812 15.7388 18.5793 15.7388C18.777 15.7388 19.1577 16.1894 19.4534 16.2304C19.7215 16.2675 20.2443 15.9621 20.2443 15.9621C20.2443 15.9621 20.5364 15.5241 20.9033 15.9866",
    stroke: "white",
    strokeWidth: 0.533333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1436 14.8827L15.6589 14.0907C15.849 13.884 16.1681 13.6802 16.6339 13.455L16.86 13.4404C17.343 13.6059 17.6658 13.6776 17.7841 13.6618C17.8231 13.6566 17.8883 13.6144 18.0074 13.509C18.3456 13.2099 18.3784 13.1855 18.5792 13.1855C18.7628 13.1855 18.8006 13.209 19.1842 13.4852C19.2554 13.5361 19.2822 13.5546 19.3207 13.5793C19.4017 13.6312 19.4597 13.6576 19.4916 13.6618C19.5837 13.6741 19.7692 13.6168 20.0287 13.4775C20.3662 13.0685 20.7937 13.1109 21.1615 13.5576C21.4068 13.8557 21.6037 14.0964 21.7524 14.2801L21.2313 15.0299C21.0844 14.8484 20.889 14.6095 20.6451 14.3133C20.5482 14.1955 20.569 14.1963 20.5259 14.2585L20.3933 14.3827C19.9907 14.6094 19.6727 14.7133 19.4152 14.679C19.2769 14.6605 19.1433 14.5996 18.9889 14.5009C18.9373 14.4678 18.9004 14.4422 18.8199 14.3847C18.6348 14.2514 18.5644 14.2078 18.5792 14.2078C18.6115 14.2078 18.5668 14.241 18.4312 14.3609C18.2131 14.5538 18.0613 14.6521 17.8605 14.679C17.6386 14.7086 17.2924 14.6373 16.7861 14.4699C16.4572 14.6357 16.2387 14.7793 16.1436 14.8827Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5049 17.6274C16.5049 17.6274 17.2121 18.5306 16.785 19.1426C16.358 19.7546 15.9664 19.3991 15.9664 19.3991",
    stroke: "#B85F3C",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8797 17.6274C20.8797 17.6274 20.1724 18.5306 20.5995 19.1426C21.0265 19.7546 21.4181 19.3991 21.4181 19.3991",
    stroke: "#B85F3C",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.043 18.3555C16.043 18.3555 17.2614 19.9079 18.7592 19.9079C20.2571 19.9079 21.4624 18.7219 21.4624 18.7219",
    stroke: "#CB8B73",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2441_3837)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2441_3837",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFkp);
export default __webpack_public_path__ + "static/media/FKP.6d81f36c22dbbecd8c352b300f78b0dd.svg";
export { ForwardRef as ReactComponent };